import { Record } from 'immutable';

export default class WorkTypeRecord extends Record({
  id: null,
  type: null,
  name: null,
  booking: null,
}) {
}
